import React from 'react';
import { stockLevel, formatPrice } from '../../server/inventory.js';

const LEVELS = {
  in: { label: 'In stock', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/30' },
  low: { label: 'Low stock', cls: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/30' },
  out: { label: 'Out of stock', cls: 'bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700' },
  unknown: { label: 'Stock not listed', cls: 'bg-slate-50 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700' },
};

/** Stock status chip: "In stock · 4". */
export const StockBadge = ({ qty }) => {
  const level = stockLevel(qty);
  const { label, cls } = LEVELS[level];
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap border px-2 py-0.5 font-cond text-[11px] font-semibold uppercase tracking-wider ${cls}`}>
      {label}
      {(level === 'in' || level === 'low') && <span className="font-mono normal-case tracking-normal">· {qty}</span>}
    </span>
  );
};

/**
 * One-line summary for a result row: the shop's best match for this part.
 * `active` is true when the shop has a list, so a part missing from it reads "Not in your list".
 */
export const ShopStockLine = ({ inventory = [], active = false }) => {
  if (!active) return null;
  const best = inventory.find((i) => i.match === 'exact') || inventory[0];
  if (!best) {
    return <div className="text-xs text-slate-500">Not in your shop list</div>;
  }
  const price = formatPrice(best.price);
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
      <StockBadge qty={best.qty} />
      {price && <span className="font-mono font-semibold text-slate-900 dark:text-white">{price}</span>}
      {best.match === 'alternate' && (
        <span className="text-slate-600 dark:text-slate-400">
          via alternate <span className="font-mono">{best.pn}</span>
        </span>
      )}
    </div>
  );
};
